/**
 * FRONT_DOOR_HERO — the front door's top band. #1618 (D440, D442): the engineering drawing from the brand kit
 * (`illustration/hero-front-door`), converted to WebP at 2x its display size (1100px wide, quality 82, under 60 kB),
 * replaced the dawn photograph (#883, D164) that stood here. `FrontDoorNew.jsx` reads only this one constant.
 *
 * The drawing is phone-first, with the detail in the middle, so the band crops with `object-fit: cover` at
 * `object-position: center`. It carries no text or number (R-001) and is a content image with alt text, not a
 * decoration.
 *
 * The photo files under `public/images/front-door/` are no longer referenced; they stay until a later cleanup.
 */
export const FRONT_DOOR_HERO = {
  src: "/images/illustration/hero-front-door.webp",
  width: 1100,
  height: 458,
  alt: "An engineering drawing of a club cricket ground with a compass rose over the outfield.",
};
